import * as yup from 'yup'

export const schema = yup.object().shape({
  observations: yup.string().required(),
})

export default schema
